import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin, Twitter, Instagram } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

const Footer = () => {
  const { t, language } = useLanguage();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-6">
              <span className="text-2xl font-bold">
                ImpaKt <span className="text-cyan-400">Studio</span>
              </span>
            </Link>
            <p className="text-gray-400 mb-6 leading-relaxed">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-cyan-500 transition-colors" data-testid="social-linkedin">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-cyan-500 transition-colors" data-testid="social-twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-cyan-500 transition-colors" data-testid="social-instagram">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              <li><Link to="/services/visibilite" className="text-gray-400 hover:text-white transition-colors">{t('nav.visibility')}</Link></li>
              <li><Link to="/services/image-de-marque" className="text-gray-400 hover:text-white transition-colors">{t('nav.brandImage')}</Link></li>
              <li><Link to="/services/croissance" className="text-gray-400 hover:text-white transition-colors">{t('nav.growth')}</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors">{t('nav.allServices')}</Link></li>
            </ul>
          </div>

          {/* Liens utiles */}
          <div>
            <h4 className="text-lg font-semibold mb-6">{t('footer.quickLinks')}</h4>
            <ul className="space-y-3">
              <li><Link to="/offres" className="text-gray-400 hover:text-white transition-colors">{t('nav.offers')}</Link></li>
              <li><Link to="/a-propos" className="text-gray-400 hover:text-white transition-colors">{t('nav.about')}</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-6">{t('footer.contactUs')}</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-cyan-400 mt-0.5" />
                <a href="mailto:contact@impakt-studio.com" className="text-gray-400 hover:text-white transition-colors">
                  contact@impakt-studio.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-cyan-400 mt-0.5" />
                <a href="tel:+33975953796" className="text-gray-400 hover:text-white transition-colors">
                  +33 9 75 95 37 96
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-cyan-400 mt-0.5" />
                <span className="text-gray-400">
                  Lyon, Paris, Genève, Bruxelles
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} ImpaKt Studio. {t('footer.rights')}
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors">
              {language === 'fr' ? 'Mentions légales' : 'Legal notice'}
            </a>
            <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors">
              {language === 'fr' ? 'Politique de confidentialité' : 'Privacy policy'}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
